<template>
    <div class="serviceM">
        <div class="serviceMM">
            <h2>服务模块</h2>
            <div class="MMcont">
                <div class="Mcont">
                    <div class="contM" v-for="item in menuList">
                        <div class="conImg" :style="{'background': 'url('+item.icon+') no-repeat center center'}">
                            <p>{{item.title}}</p>
                        </div>
                        <div class="conTxt">
                            <div>
                                <p>{{item.small1}}</p>
                                <p>{{item.small3}}</p>
                            </div>
                            <div>
                                <p>{{item.small2}}</p>
                                <p>{{item.small4}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="gdfw">
            <div class="cont">
                <div class="contImg" style="float: left">
                    <!-- <div class="contP">
                        <span>彩虹律师高端服务</span>
                    </div>
                    <div class="name">
                        <img src="../assets/img/p1.png" alt="">
                        <span>专业提供企业法律法务</span>
                    </div> -->
                    <img src="../assets/img/组13.png">
                </div>
                <el-button @click="Tocontact" style="float: right;margin-top: 80px;">立即申请</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import Bus from './bus.js'
    export default {
        name: "serviceM",
        data(){
            return{
                isShow:true,
                menuList:[
                    {
                        id:1,
                        title:'劳资模块',
                        icon:require('../assets/img/劳资模块.png'),
                        small1:"员工规范管理",
                        small2:'劳动合同管理',
                        small3:'劳动纠纷管理',
                        small4:'其他纠纷管理'
                    },
                    {
                        id:2,
                        title:'合约模块',
                        icon:require('../assets/img/合约模块.png'),
                        small1:"合同基础事项",
                        small2:'合同条款审查',
                        small3:'买卖合同事项',
                        small4:'其他合同事项'
                    },
                    {
                        id:3,
                        title:'企业股权模块',
                        icon:require('../assets/img/企业股权模块.png'),
                        small1:"企业股权架构",
                        small2:'企业期权池设计',
                        small3:'企业股权变更',
                        small4:'股权特殊事项'
                    },
                    {
                        id:4,
                        title:'催收欠款模块',
                        icon:require('../assets/img/催收欠款模块.png'),
                        small1:"催收欠款流程",
                        small2:'催收欠款方式',
                        small3:'企业提供资料清单'
                    },
                    {
                        id:5,
                        title:'知识产权模块',
                        icon:require('../assets/img/知识产权模块.png'),
                        small1:"商标事项",
                        small2:'专利事项',
                        small3:'著作权事项',
                        small4:'商业秘密事项'
                    },
                    {
                        id:6,
                        title:'增值服务模块',
                        icon:require('../assets/img/增值服务模块.png'),
                        small1:"每周安排一次讲座",
                        small2:'诉讼',
                        small3:'仲裁',
                        small4:''
                    },
                ]

            }
        },
        methods:{
            Tocontact(){
                this.isShow = !this.isShow;
                this.$emit('childByBtn', this.isShow);
                // console.log("111");
                this.isShow = !this.isShow;
            },
        }
    }
</script>

<style lang="less" scoped>
    .serviceMM{
        background: url("../assets/img/background.png") no-repeat;
        background-size: cover;
        width: 100%;
        height: 860px;
        h2{
            padding-top: 80px;
            font-size: 30px;
            color: rgb(43,43,43);
            text-align: center;
        }
        .MMcont{
            display: flex;
            justify-content: center; /* 水平居中 */
            align-items: center;     /* 垂直居中 */
            padding-top:20px;
            .Mcont{
                width: 1164px;
                height: 640px;
                .contM{
                    transition: 0.1s all;
                    float: left;
                    margin: 34px;
                    width: 320px;
                    height: 290px;
                    box-shadow: 0 5px 21px 0 rgba(3,20,58,0.14);
                    .conImg{
                        width: 100%;
                        height: 200px;
                        background: url("../assets/img/劳资模块.png") no-repeat;
                        background-size: cover;
                        display: flex;
                        justify-content: center; /* 水平居中 */
                        align-items: center;     /* 垂直居中 */
                        p{
                            font-size: 24px;
                            color: white;
                        }
                    }
                    .conTxt{
                        width: 100%;
                        height: 90px;
                        background: white;
                        div{
                            width: 50%;
                            height: 100%;
                            /*text-align: center;*/
                            p{
                                line-height: 45px;
                                /*padding-left: 20px;*/
                                font-size: 16px;
                            }
                            p:nth-child(1){
                                width: 100%;
                            }

                        }
                        div:nth-child(1){
                            float: left;
                            p{
                                padding-left: 25px;
                            }
                        }
                        div:nth-child(2){
                            float: right;
                            p{
                                padding-left: 25px;
                            }
                        }
                    }
                }
                .contM:hover{
                    transform: scale(1.1);
                }
            }
        }

    }
    .gdfw{
        width: 100%;
        height: 200px;
        background: url("../assets/img/banner2.png") no-repeat;
        background-size: cover;
        .cont{
            width: 800px;
            height: 100%;
            margin: 0 auto;
            .contImg{
                padding-top:50px;
            }
            .el-button{
                width:150px;
                height:50px;
                border-radius:8px;
                color:rgb(50,150,250);
                background:white;
                font-size:14px;
                font-weight:550;
            }
            .contP{
                padding-top: 53px;
                width: 328px;
                height: 46px;
                border-bottom: 1px solid white;
                span{
                    font-size: 36px;
                    text-align: center;
                    color: white;
                    letter-spacing:5px;
                }
            }
            .name{
                text-align: center;
                width: 328px;
                height:38px;
                position:relative;
                img{
                    position:absolute;
                    top:10px;
                    left:14px;
                    height: 30px;
                }
                span{
                    position:absolute;
                    top:8px;
                    left:45px;
                    line-height: 38px;
                    font-size: 24px;
                    color: white;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/serviceM.vue